import { render, staticRenderFns } from "./subscriptionNumber.vue?vue&type=template&id=452a6160&scoped=true&"
import script from "./subscriptionNumber.vue?vue&type=script&lang=js&"
export * from "./subscriptionNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452a6160",
  null
  
)

export default component.exports